export const BACKEND_URI = process.env.REACT_APP_BACKEND_URI;
export const GA_DISABLED = process.env.REACT_APP_GA_DISABLED === "true";

export const URL_REGEX = new RegExp('^(ftp|http|https):\\/\\/[^ "]+$');
export const EMAIL_REGEX = new RegExp('^(([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$');
export const NUMBER_REGEX = new RegExp('^\\d+$');

export const INVALID_FIELD_STYLE = { border: '1px solid red' };


// WEBPACK FOOTER //
// ./src/utils/Constants.ts